import { createLogic } from 'redux-logic'
import { map } from 'rxjs/operators'
import * as constants from '../constants'
import Comps from '@engine/comps'

export const getProjectById = createLogic({
  type: constants.GET_PROJECT_BY_ID.ACTION,
  processOptions: {
    successType: constants.GET_PROJECT_BY_ID.FULFILLED,
    failType: constants.GET_PROJECT_BY_ID.REJECTED
  },
  process({ getState, http }) {
    const state = getState()
    const projectId = Comps.selectors.comps.selectedProjectId(state) || state.selectedProjectId

    return http
      .get(`/comps/project/${projectId}`)
      .pipe(
        map(http.getBody),
        map(res => {
          // eslint-disable-next-line
          window._mtm.push({ 'event': 'previewProject', 'projectName': res.projectName, 'previewAction': 'by cliking on project card' })

          return res
        })
      )
  }
})
